export function messageBoxFrame(title, ...children) {
    return <div class="messagebox">
        <div class="messagebox__wrapper">
            <div class="container">
                <div class="container__title">
                    <div class="container__title__background"/>
                    <div class="container__title__text">{title}</div>
                </div>
                {...children}
            </div>
        </div>
    </div>;
}

export async function showConfirmBox(text, title, target) {
    let result = false;

    await showMessageBox(text, title, [
        { text: 'Yes', callback: async () => result = true },
        { text: 'No' },
    ], target);

    return result;
};

export function showMessageBox(text, title='Information', buttons=null, target=null, focus=null) {
    if(!(text instanceof Node) && typeof text !== 'string') {
        if(text !== undefined && text !== null && typeof text.toString === 'function')
            text = text.toString();
        else throw 'text must be a string';
    }
    if(!(target instanceof Node))
        target = document.body;

    if(!Array.isArray(buttons))
        buttons = [];

    return new Promise((resolve, reject) => {
        if(target.querySelector('.messagebox')) {
            reject();
            return;
        }

        let buttonsElem;
        const html = messageBoxFrame(title, <>
            <div class="messagebox__content">{text}</div>
            {buttonsElem = <div class="messagebox__buttons"/>}
        </>);

        if(buttons.length < 1) {
            buttonsElem.appendChild(<button class="input__button" onclick={() => {
                html.remove();
                resolve();
            }}>OK</button>);
        } else {
            for(const button of buttons) {
                const buttonElem = <button class="input__button" onclick={() => {
                    html.remove();

                    if(typeof button.callback === 'function')
                        button.callback().finally(() => resolve());
                    else
                        resolve();
                }}>{button.text}</button>;
                buttonsElem.appendChild(buttonElem);
            }
        }

        target.appendChild(html);
        focus ??= buttons => { buttons.firstChild.focus(); }
        focus(buttonsElem);
    });
};
